// extracted by mini-css-extract-plugin
export default {"wrapperContent":"DesktopLayout_wrapperContent__J7pBz","desktopContent":"DesktopLayout_desktopContent__I6waR","desktopBody":"DesktopLayout_desktopBody__VIvZw"};